import { render, staticRenderFns } from "./StudentPetDetailDrawer.vue?vue&type=template&id=5336a236&scoped=true"
import script from "./StudentPetDetailDrawer.vue?vue&type=script&lang=js"
export * from "./StudentPetDetailDrawer.vue?vue&type=script&lang=js"
import style0 from "./StudentPetDetailDrawer.vue?vue&type=style&index=0&id=5336a236&prod&lang=css"
import style1 from "./StudentPetDetailDrawer.vue?vue&type=style&index=1&id=5336a236&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5336a236",
  null
  
)

export default component.exports